import { useQuery } from '@tanstack/react-query';
import { getExpressionParams } from 'config/requests/gatewayRules';
import { ExpressionParam } from 'types/embedded/gatewayRule';

type UseExpressionParamsReturnValues = {
  expressionParams: ExpressionParam[];
  loadingExpressionParams: boolean;
};

export function useExpressionParams(): UseExpressionParamsReturnValues {
  const { data: expressionParams = [], isLoading: loadingExpressionParams } = useQuery<
    ExpressionParam[]
  >({ queryKey: ['expression_params'], queryFn: getExpressionParams });

  return { expressionParams, loadingExpressionParams };
}
